import { render } from "./StepCardsMobile.vue?vue&type=template&id=79df2221&scoped=true"
import script from "./StepCardsMobile.vue?vue&type=script&lang=js"
export * from "./StepCardsMobile.vue?vue&type=script&lang=js"

import "./StepCardsMobile.vue?vue&type=style&index=0&id=79df2221&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79df2221"]])

export default __exports__